// extracted by mini-css-extract-plugin
module.exports = {"container":"trustpilot-score_container__txLGx","trustpilotStars":"trustpilot-score_trustpilotStars__KZmW3","trustpilotLogo":"trustpilot-score_trustpilotLogo___GRtr"};